(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('revisionMapper', revisionMapper);

	function revisionMapper(_, userMapper) {
		function mapRevision(source) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(mapRevision);

			return {
				id: source.id,
				date: source.date,
				changes: source.changes && source.changes.ops,
				creator: userMapper.map(source.agent.user)
			};
		}

		return {
			map: mapRevision
		};
	}
	revisionMapper.$inject = ['_', 'userMapper'];
})();